
    <fieldmagic-dialog
      label="Resolution Notes"
      icon="file-alt"
      [instance]="this"
    >
      <ng-template fieldmagicDialogButtonsTmp>
        <fieldmagic-primary-button
          purpose="save"
          (click)="onSave()"
        >
        </fieldmagic-primary-button>
      </ng-template>

      <ng-template fieldmagicDialogContentTmp>
        <div class="d-flex flex-column">
          <fieldmagic-textarea-input
            label="Resolution Notes"
            placeholder="Add notes..."
            [standalone]="false"
            [expandable]="true"
            [(ngModel)]="notes"
          >
          </fieldmagic-textarea-input>

          <small
            *ngIf="resolutionDate | filled"
            class="text-muted"
          >
            {{ 'Date Resolved: %s' | translate | sprintf: [resolutionDate] }}
          </small>
        </div>
      </ng-template>
    </fieldmagic-dialog>
  